<template>
  <div class="shibie">
    <div class="title">人脸识别</div>
    <canvas id="canvasCemara" width="500" height="500"></canvas>
    <video autoplay="" id="video2" style="width:500px;height:500px;"></video>
    <button id="btn">拍摄</button>
  </div>
</template>

<script>
var video = document.getElementById('video2');
var constraints = {audio: false, video: true};

export default {
  data() {
    return {
    };
  },

  methods: {
    init() {
      navigator.webkitGetUserMedia('video', this.gotStream, this.noStream)
    },
    gotStream(stream) {
      video.srcObject = stream;
      video.play();
    },

    noStream() {

    }
  },

  created() {
    this.init()
  },
}
</script>

<style scoped lang="scss">
  .shibie{
    margin: 0.5rem;
    .title{
      text-align: center;
      line-height: 0.5rem;
    }
  }
</style>
